import { EApi } from '../interfaces/BaseApiResponse';

export const PRE_SIGNUP = {
  url: '/v1.0/config/preSignUp',
  en: EApi.FETCH_PRE_SIGN_UP_APP_CONFIG,
};
export const REFRESH_TOKEN = {
  url: '/v1.0/refreshToken',
  en: '' as EApi,
};
export const REQUEST_SIGNUP_OTP = {
  url: '/v1.0/user/requestSignupOtp',
  en: EApi.REQUEST_SIGNUP_OTP,
};
export const AUTHENTICATE_USER = {
  url: '/v1.0/auth/authenticateUser',
  en: EApi.AUTHENTICATE_USER,
};
export const USER_DETAILS = {
  url: '/v1.0/user/getUserDetails',
  en: EApi.GET_USER_DETAILS,
};
export const TOURNAMENTS_LIST = {
  url: '/v1.0/pwa/internal/getPwaHomeScreen',
  en: EApi.GET_TOURNAMENTS_LIST
}
export const TOURNAMENT_LIST_PUBLIC = {
  url: 'v1.0/pwa/public/getPwaHomeScreen',
  en: EApi.GET_PWA_HOME_SCREEN
}
export const GET_TOURNAMENT_DETAILS = {
  url: '/v1.0/super/tournament/getTournamentDetails',
  en: EApi.GET_TOURNAMENT_DETAILS
}
export const GET_LEADERBOARD_DETAILS = {
  url:'/v1.0/super/tournament/getLeaderboard',
  en: EApi.GET_LEADERBOARD_DETAILS
}
export const REGISTER_TOURNAMENTS = {
  url: '/v1.0/super/tournament/registerTournament',
  en: EApi.REGISTER_TOURNAMENT
}
export const GET_GAME_CONFIG = {
  url: 'v1.0/super/config/getGameConfigs',
  en: EApi.GET_GAME_CONFIG
}
export const GET_TOURNAMENTS_HISTORY = {
  url: '/v1.0/super/tournament/getTournamentsHistory',
  en: EApi.GET_TOURNAMENTS_HISTORY,
};
export const SET_USER_LOCATION = {
  url: '/v1.0/user/setLocation',
  en: EApi.SET_USER_LOCATION
}
export const GET_WINNING_BANNER = {
  url: 'v1.0/super/postGamePlay/pwaWD',
  en: EApi.GET_PWA_POST_GAME_WD_DATA_EVENT
}

/* ---------------------------- Withdrawal ---------------------------- */

export const INITIATE_WITHDRAW = {
  url: '/v1.0/payment/initializeWithdrawalSession',
  en: EApi.INITIATE_WITHDRAW,
};
export const WITHDRAW_BREAKDOWN = {
  url: '/v1.0/payment/withdrawalDebounceWidgetData',
  en: EApi.WITHDRAW_BREAKDOWN,
};
export const PROCESS_WITHDRAWAL = {
  url: '/v1.0/payment/processWithdrawal',
  en: EApi.PROCESS_WITHDRAWAL,
};
export const PAYOUT_STATUS_SCREEN = {
  url: '/v1.0/payment/getPayoutStatusScreenData',
  en: EApi.PAYOUT_STATUS_SCREEN,
};
export const GET_WALLET_SCREEN_DATA = {
  url: '/v1.0/wallet/getWalletScreenData',
  en: EApi.GET_WALLET_SCREEN_DATA,
};
export const GET_SAVED_WITHDRAWAL_MODES = {
  url: '/v1.0/payment/getSavedWithdrawalModes',
  en: EApi.GET_SAVED_WITHDRAWAL_MODES,
};
export const ADD_UPI_ID = {
  url: '/v1.0/user/addUpiId',
  en: EApi.ADD_UPI_ID,
};
export const SUBMIT_BANK_DETAILS = {
  url: '/v1.0/payment/bank/submit',
  en: EApi.SUBMIT_BANK_DETAILS,
};
export const GET_WITHDRAWAL_SCREEN_BOTTOMSHEET = {
  url: '/v1.0/payment/getWithdrawalScreenBottomsheet',
  en: EApi.GET_WITHDRAWAL_SCREEN_BOTTOMSHEET,
};

/* ------------------------------- KYC -------------------------------- */

export const GET_KYC_LANDING_DATA = {
  url: '/v1.0/kyc/getKycDocsV4',
  en: EApi.GET_KYC_LANDING_DATA,
};
export const INITIALIZE_DIGILOCKER_KYC = {
  url: '/v1.0/kyc/initializeDigiLockerKyc',
  en: EApi.INITIALIZE_DIGILOCKER_KYC,
};
export const COMPLETE_DIGILOCKER_KYC = {
  url: '/v1.0/kyc/completeDigiLockerKyc',
  en: EApi.COMPLETE_DIGILOCKER_KYC,
};
